module.exports = __webpack_public_path__ + "img/kayak_1413_4.57f1139c.jpg";